export const TESTIDS = {
  // Login
  loginPage: "login-page",
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",

  // Layout / Nav
  appShell: "app-shell",
  navLogo: "nav-logo",
  navDashboard: "nav-dashboard",
  navHistory: "nav-history",
  navLeave: "nav-leave",
  navOvertime: "nav-overtime",
  navApprovals: "nav-approvals",
  navAdminDashboard: "nav-admin-dashboard",
  navAdminUsers: "nav-admin-users",
  navAdminOffices: "nav-admin-offices",
  navAdminWfa: "nav-admin-wfa",
  navAdminReports: "nav-admin-reports",
  navAdminSettings: "nav-admin-settings",
  navUserMenu: "nav-user-menu",
  navLogout: "nav-logout",
  navChangePassword: "nav-change-password",

  // Employee dashboard
  empDashboard: "employee-dashboard",
  digitalClock: "digital-clock",
  cameraFeed: "camera-feed",
  cameraStart: "camera-start-btn",
  cameraCapture: "camera-capture-btn",
  cameraRetake: "camera-retake-btn",
  cameraPreview: "camera-preview-img",
  mapWidget: "map-widget",
  distanceIndicator: "distance-indicator",
  checkInBtn: "check-in-btn",
  checkOutBtn: "check-out-btn",
  statusBadge: "status-badge",
  todayCard: "today-card",
  wfaBanner: "wfa-banner",

  // History
  historyPage: "history-page",
  historyTable: "history-table",

  // Leave
  leavePage: "leave-page",
  leaveNewBtn: "leave-new-btn",
  leaveSubmit: "leave-submit-btn",
  leaveTable: "leave-table",

  // Overtime
  overtimePage: "overtime-page",
  overtimeNewBtn: "overtime-new-btn",
  overtimeSubmit: "overtime-submit-btn",
  overtimeTable: "overtime-table",

  // Approvals
  approvalsPage: "approvals-page",
  approveBtn: "approve-btn",
  rejectBtn: "reject-btn",

  // Admin
  adminDashboardPage: "admin-dashboard-page",
  statTotal: "stat-total",
  statOnTime: "stat-on-time",
  statLate: "stat-late",
  statAbsent: "stat-absent",
  statPendingLeave: "stat-pending-leave",
  statPendingOvertime: "stat-pending-overtime",
  todayTable: "today-table",

  adminUsersPage: "admin-users-page",
  usersTable: "users-table",
  createUserBtn: "create-user-btn",
  editUserBtn: "edit-user-btn",
  resetPassBtn: "reset-pass-btn",
  deleteUserBtn: "delete-user-btn",
  userFormEmail: "user-form-email",
  userFormName: "user-form-name",
  userFormPassword: "user-form-password",
  userFormRole: "user-form-role",
  userFormWfa: "user-form-wfa",
  userFormSubmit: "user-form-submit",

  adminOfficesPage: "admin-offices-page",
  officesTable: "offices-table",
  createOfficeBtn: "create-office-btn",
  officeFormName: "office-form-name",
  officeFormLat: "office-form-lat",
  officeFormLng: "office-form-lng",
  officeFormRadius: "office-form-radius",
  officeFormUseCurrent: "office-form-use-current",
  officeFormSubmit: "office-form-submit",

  adminWfaPage: "admin-wfa-page",
  wfaTable: "wfa-table",
  wfaAddBtn: "wfa-add-btn",
  wfaUserSelect: "wfa-user-select",
  wfaDatePicker: "wfa-date-picker",
  wfaNote: "wfa-note",
  wfaSubmit: "wfa-submit",

  adminUnitsPage: "admin-units-page",
  navAdminUnits: "nav-admin-units",
  unitsTable: "units-table",
  createUnitBtn: "create-unit-btn",
  unitFormName: "unit-form-name",
  unitFormCode: "unit-form-code",
  unitFormSubmit: "unit-form-submit",
  userFormUnit: "user-form-unit",

  adminReportsPage: "admin-reports-page",
  dateFromPicker: "date-from-picker",
  dateToPicker: "date-to-picker",
  exportCsvBtn: "export-csv-btn",
  reportsTable: "reports-table",

  adminSettingsPage: "admin-settings-page",
  inputCompanyName: "input-company-name",
  inputCheckInTime: "input-check-in-time",
  inputCheckOutTime: "input-check-out-time",
  saveSettingsBtn: "save-settings-btn",

  changePasswordPage: "change-password-page",
  cpCurrent: "cp-current",
  cpNew: "cp-new",
  cpConfirm: "cp-confirm",
  cpSubmit: "cp-submit",
};
